"use client";

import { ArticleContent } from "@features/article-content/ui";
import { ArticleHero } from "@features/article-hero";
import { MoreArticles } from "@features/more-articles";

import type { GlobalType } from "@shared/content-types/types";

import type { ArticleType } from "../model";

import s from "./article-page.module.scss";

export type ArticlePageProps = {
  article: ArticleType;
  formSettings?: GlobalType["feedbackForm"] | null;
};

export const ArticlePage = (props: ArticlePageProps) => {
  const { article, formSettings } = props;

  return (
    <main className={s.root}>
      {article.hero && (
        <ArticleHero data={article.hero} createdAt={article.createdAt} />
      )}
      {article.content && (
        <ArticleContent
          articleBlocks={article.content}
          formSettings={formSettings}
        />
      )}
      {article.moreArticles && article.moreArticles.length > 0 && (
        <MoreArticles data={article.moreArticles} />
      )}
    </main>
  );
};

ArticlePage.displayName = "ArticlePage";
